// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__pr9SI","colCheckbox":"styles_colCheckbox__3aYoz"};